<mat-tab-group (selectedTabChange)="tabChanged($event)">
  <mat-tab label="Meraki">
    <ng-container *ngIf="selectedTab === true"> </ng-container>
  </mat-tab>
  <mat-tab label="ABB">
    <ng-container *ngIf="selectedTab === false"> </ng-container>
  </mat-tab>
</mat-tab-group>
<div class="container">
  <!-- High-Tech Glassmorphism Prefill Loader Overlay -->
  <div class="prefill-loading-overlay" *ngIf="isPrefillLoading">
    <div class="prefill-loading-modal">
      <div class="radar-pulse-ring">
        <mat-spinner diameter="54" class="prefill-mat-spinner"></mat-spinner>
        <mat-icon class="radar-ship-icon">directions_boat</mat-icon>
      </div>
      <div class="prefill-modal-text">
        <h3 class="modal-title">{{ prefillLoadingTitle }}</h3>
        <p class="modal-sub">{{ prefillLoadingSub }}</p>
      </div>
      <div class="prefill-steps-progress">
        <span class="step-pill active"><mat-icon>auto_awesome</mat-icon> Vessel Dimensions</span>
        <span class="step-pill active"><mat-icon>location_on</mat-icon> Port Coordinates</span>
        <span class="step-pill active"><mat-icon>speed</mat-icon> Speed & Fuel Profile</span>
      </div>
    </div>
  </div>

  <!-- High-Tech Submission Loader Overlay -->
  <div class="prefill-loading-overlay submit-loading-overlay" *ngIf="isSubmitting">
    <div class="prefill-loading-modal">
      <div class="radar-pulse-ring">
        <mat-spinner diameter="54" class="prefill-mat-spinner"></mat-spinner>
        <mat-icon class="radar-ship-icon">route</mat-icon>
      </div>
      <div class="prefill-modal-text">
        <h3 class="modal-title">Generating Route Simulation</h3>
        <p class="modal-sub">Calculating weather impact, speed & fuel consumption profiles...</p>
      </div>
    </div>
  </div>

  <div class="form-container">
    <div class="bg-gradient-to-r-custom border-b border-slate-600">
      <h1 class="text-xl font-semibold text-white flex items-center gap-2">
        Maritime Route Planning
      </h1>
      <p class="text-slate-300 text-sm mt-1">Configure voyage parameters</p>
    </div>

    <div
      class="alert alert-danger mx-4 mt-3 mb-2 d-flex align-items-start"
      *ngIf="simulationError"
      style="border-radius: 8px; border-left: 5px solid #dc3545; background-color: #fff5f5; color: #721c24; box-shadow: 0 2px 8px rgba(220,53,69,0.12); padding: 14px 16px;"
    >
      <i class="fa-solid fa-triangle-exclamation me-3 mt-1" style="font-size: 20px; color: #dc3545;"></i>
      <div style="flex: 1;">
        <h5 style="margin: 0 0 4px 0; font-weight: 700; color: #dc3545; font-size: 14px;">Route Simulation Notice / Error</h5>
        <p style="margin: 0; font-size: 13px; line-height: 1.5; white-space: pre-wrap;">{{ simulationError }}</p>
      </div>
      <button type="button" class="btn-close ms-2" (click)="simulationError = null" aria-label="Close" style="background-size: 10px;"></button>
    </div>
    <div class="fieldsContent">
      <p
        class="title"
        *ngIf="
          selectedType !== 'jupiter Route' && selectedType !== 'Upload Route'
        "
      >
        {{ selectedType }}
      </p>
      <p class="title" *ngIf="selectedType === 'jupiter Route'">
        Meraki Route Fields
      </p>
      <p class="title" *ngIf="selectedType === 'Upload Route'">Upload MIR</p>
      <div class="report-type-icons">
        <div
          class="report-icon"
          *ngFor="let type of reportTypes"
          [class.active]="selectedType === type"
          (click)="selectReportType(type)"
          [matTooltip]="
            type === 'jupiter Route'
              ? 'Meraki Route'
              : type === 'Upload Route'
                ? 'Upload MIR'
                : type
          "
        >
          <i class="fa-solid" [ngClass]="getIcon(type)"></i>
        </div>
      </div>
      <form [formGroup]="requestForm">
        <div
          class="commonFields"
          *ngIf="
            selectedType !== 'jupiter Route' &&
            selectedType !== 'Upload Route' &&
            selectedTab === false
          "
        >
          <h3 class="FieldsText">Common Fields</h3>
          <div class="row">
            <div class="col-md-6">
              <label class="shipNameLabel"
                ><span class="asterik-color">*</span>Vessel Name
              </label>
              <input
                type="text"
                class="form-control shipName"
                id="shipName"
                formControlName="vesselName"
                (input)="filterShipNames($event)"
                [matAutocomplete]="autoShip"
              />
              <mat-autocomplete #autoShip="matAutocomplete">
                <mat-option
                  *ngFor="let ship of shipNameSuggestions"
                  [value]="ship.vessel_name"
                >
                  {{ ship.vessel_name }}
                </mat-option>
              </mat-autocomplete>
              <div
                *ngIf="
                  formSubmitted && requestForm.controls['vesselName'].invalid
                "
                style="color: red"
                class="errorMsg"
              >
                Vessel name is required
              </div>
            </div>
            <div class="col-md-6">
              <label class="shipNameLabel"
                ><span class="asterik-color">*</span>Vessel Type
              </label>
              <input
                type="text"
                formControlName="vesselType"
                [matAutocomplete]="autoVesselType"
                class="form-control"
              />

              <mat-autocomplete #autoVesselType="matAutocomplete">
                <mat-option
                  *ngFor="let option of filteredOptions"
                  [value]="option.label"
                >
                  {{ option.label }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [label]="'IMO'"
                [controlname]="requestForm.controls['imo']"
                [errorMessage]="'IMO is required'"
                [formSubmitted]="formSubmitted"
                [required]="true"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'Year Built'"
                [controlname]="requestForm.controls['yearBuilt']"
                [errorMessage]="'year built is required'"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label class="shipNameLabel"
                ><span class="asterik-color">*</span>Start Port Name
              </label>
              <input
                type="text"
                matInput
                formControlName="startPortName"
                [matAutocomplete]="auto"
                (input)="filterPorts()"
                required
                class="form-control"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onPortSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let port of filteredPorts"
                  [value]="port.properties.name"
                >
                  {{ port.properties.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'Start Port Id'"
                [controlname]="requestForm.controls['startPortId']"
                [errorMessage]="'Start lon is required'"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
          </div>
          <div class="row">
            <!-- <div
              class="col-md-1 viaPoint"
              [matTooltip]="'Add Via points'"
              (click)="addViaPoint()"
            >
              <mat-icon>add_circle</mat-icon>
            </div> -->
            <div class="col-md-6">
              <app-custom-input
                [label]="'Start Latitude'"
                [controlname]="requestForm.controls['startLat']"
                [errorMessage]="'Start lat is required'"
                [formSubmitted]="formSubmitted"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'Start Longitude'"
                [controlname]="requestForm.controls['startLon']"
                [errorMessage]="'Start lon is required'"
                [formSubmitted]="formSubmitted"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="myLocation">
              <mat-icon (click)="enableLocationSelect('startLat', 'startLon')"
                >my_location</mat-icon
              >
            </div>
          </div>
          <div class="row" *ngFor="let point of viaPoints; let i = index">
            <div class="col-md-1 viaPoint">
              <mat-icon
                *ngIf="i === viaPoints.length - 1"
                matTooltip="Add Via point"
                class="text-success cursor-pointer viaPointIcon"
                (click)="addViaPoint()"
                >add_circle</mat-icon
              >

              <mat-icon
                *ngIf="viaPoints.length > 1"
                matTooltip="Remove Via point"
                class="text-danger cursor-pointer"
                (click)="removeViaPoint(i)"
                >remove_circle</mat-icon
              >
            </div>

            <div class="col-md-5">
              <app-custom-input
                [label]="'Via Point Lat' + (i + 1)"
                [controlname]="requestForm.controls[point.lat]"
                [errorMessage]="'Latitude is required'"
                [formSubmitted]="formSubmitted"
              ></app-custom-input>
            </div>

            <div class="col-md-6">
              <app-custom-input
                [label]="'Via Point Lon' + (i + 1)"
                [controlname]="requestForm.controls[point.lon]"
                [errorMessage]="'Longitude is required'"
                [formSubmitted]="formSubmitted"
              ></app-custom-input>
            </div>

            <div class="myLocation">
              <mat-icon
                (click)="enableLocationSelect(point.lat, point.lon)"
                class="cursor-pointer"
                >my_location</mat-icon
              >
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label class="shipNameLabel">
                <span class="asterik-color">*</span>End Port Name
              </label>
              <input
                type="text"
                class="form-control portName"
                id="endPortName"
                formControlName="endPortName"
                (input)="filterEndPorts()"
                [matAutocomplete]="autoEndPort"
                required
              />
              <mat-autocomplete
                #autoEndPort="matAutocomplete"
                (optionSelected)="onEndPortSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let port of filteredEndPorts"
                  [value]="port.properties.name"
                >
                  {{ port.properties.name }}
                </mat-option>
              </mat-autocomplete>

              <div
                *ngIf="
                  formSubmitted && requestForm.controls['endPortName'].invalid
                "
                style="color: red"
                class="errorMsg"
              >
                End Port name is required.
              </div>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'End Port ID'"
                [controlname]="requestForm.controls['endPortId']"
                [errorMessage]="'Port ID is required'"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [label]="'End Latitude'"
                [controlname]="requestForm.controls['endLat']"
                [errorMessage]="'End lat is required'"
                [formSubmitted]="formSubmitted"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'End Longitude'"
                [controlname]="requestForm.controls['endLon']"
                [formSubmitted]="formSubmitted"
                [errorMessage]="'End lon is required'"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="myLocation">
              <mat-icon (click)="enableLocationSelect('endLat', 'endLon')"
                >my_location</mat-icon
              >
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [label]="'Time Between Points'"
                [controlname]="requestForm.controls['timeBetwPoints']"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'Time Back In Hours'"
                [controlname]="requestForm.controls['timeBckInHours']"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [label]="'Weather Forecast Range'"
                [controlname]="requestForm.controls['weatherForcRange']"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'Route Summary Comment'"
                [controlname]="requestForm.controls['routeSummaryComment']"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [label]="'Way Point Comment'"
                [controlname]="requestForm.controls['waypoint_comment']"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'Weather Comment'"
                [controlname]="requestForm.controls['weather_comment']"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
          </div>
        </div>
        <!-- Common fields -->

        <!-- Instructed Set Speed -->
        <div
          *ngIf="
            selectedType !== 'Shortest path' &&
            selectedType !== 'jupiter Route' &&
            selectedType !== 'Upload Route' &&
            selectedTab === false
          "
        >
          <div class="otherFields">
            <h3 class="FieldsText">Other Fields</h3>
            <div class="row">
              <div class="col-md-6">
                <app-custom-input
                  [label]="'length of the vessel'"
                  [controlname]="requestForm.controls['lengOfVessel']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'Length of vessel is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
              <div class="col-md-6">
                <app-custom-dropdown
                  [label]="'Optimization Type'"
                  [items]="optimizationOptions"
                  [controlname]="requestForm.controls['optimizationType']"
                  [formSubmitted]="formSubmitted"
                  [requiredErrorMessage]="'Optimization type is required'"
                  [required]="true"
                ></app-custom-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <app-custom-input
                  [label]="'The issue time of the forecast'"
                  [controlname]="requestForm.controls['issueTimeOfForecast']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'Issue time of forecast is required'"
                ></app-custom-input>
              </div>
              <div
                class="col-md-6"
                *ngIf="selectedType !== 'Instructed set speed'"
              >
                <app-custom-input
                  [label]="'Beam'"
                  [controlname]="requestForm.controls['beam']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'Beam is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
              <div
                class="col-md-6"
                *ngIf="selectedType === 'Instructed set speed'"
              >
                <app-custom-input
                  [label]="'Hours Between Route Way Points'"
                  [controlname]="
                    requestForm.controls['hoursBetweenRouteWaypoints']
                  "
                  [formSubmitted]="formSubmitted"
                ></app-custom-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <app-custom-input
                  [type]="'date'"
                  [label]="'Estimated Time of Departure(UTC)'"
                  [controlname]="requestForm.controls['etdDate']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'ETD is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
              <div class="col-md-3">
                <app-custom-input
                  [type]="'number'"
                  [label]="'Hours'"
                  [controlname]="requestForm.controls['etdHours']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'ETD is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
              <div class="col-md-3">
                <app-custom-input
                  [type]="'number'"
                  [label]="'Minutes'"
                  [controlname]="requestForm.controls['etdMinutes']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'ETD is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
            </div>
            <div
              class="row"
              *ngIf="selectedType === 'Fixed ETA' && selectedTab === false"
            >
              <div class="col-md-6">
                <app-custom-input
                  [type]="'date'"
                  [label]="'Estimated Time of Arrival'"
                  [controlname]="requestForm.controls['etaDate']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'ETA is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
              <div class="col-md-3">
                <app-custom-input
                  [type]="'number'"
                  [label]="'Hours'"
                  [controlname]="requestForm.controls['etahours']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'ETD is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
              <div class="col-md-3">
                <app-custom-input
                  [type]="'number'"
                  [label]="'Minutes'"
                  [controlname]="requestForm.controls['etaMinutes']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'ETD is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
            </div>
            <div class="row" *ngIf="selectedType !== 'Instructed set speed'">
              <div class="col-md-6">
                <app-custom-input
                  [label]="'Max Speed'"
                  [controlname]="requestForm.controls['maxSpeed']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'Max speed is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
              <div class="col-md-6">
                <app-custom-input
                  [label]="'Min Speed'"
                  [controlname]="requestForm.controls['minSpeed']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'Min speed is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
            </div>
            <div class="row" *ngIf="selectedType === 'Instructed set speed'">
              <div class="col-md-6">
                <app-custom-input
                  [type]="'number'"
                  [label]="'Speed'"
                  [controlname]="requestForm.controls['speed']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'Speed is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
              <div class="col-md-6">
                <app-custom-input
                  [label]="'Beam'"
                  [controlname]="requestForm.controls['beam']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                  [errorMessage]="'Beam is required'"
                  [required]="true"
                ></app-custom-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <app-custom-input
                  [label]="'Air Draft'"
                  [controlname]="requestForm.controls['airDraft']"
                  [errorMessage]="'This is required'"
                  [formSubmitted]="formSubmitted"
                ></app-custom-input>
              </div>
              <div class="col-md-6">
                <app-custom-input
                  [label]="'Dead Weight'"
                  [controlname]="requestForm.controls['deadWeight']"
                  [formSubmitted]="formSubmitted"
                ></app-custom-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <app-custom-input
                  [label]="'After Draft'"
                  [controlname]="requestForm.controls['aftDraft']"
                  [formSubmitted]="formSubmitted"
                ></app-custom-input>
              </div>
              <div class="col-md-6">
                <app-custom-input
                  [label]="'Fore Draft'"
                  [controlname]="requestForm.controls['foreDraft']"
                  [formSubmitted]="formSubmitted"
                ></app-custom-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <app-custom-input
                  [label]="'gross Tonnage'"
                  [controlname]="requestForm.controls['grossTonnage']"
                  [formSubmitted]="formSubmitted"
                ></app-custom-input>
              </div>
              <div class="col-md-6">
                <app-custom-dropdown
                  [label]="'Dangerous Cargo'"
                  [controlname]="requestForm.controls['dangerousCargo']"
                  [items]="dangerousCargoOptions"
                  [formSubmitted]="formSubmitted"
                ></app-custom-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <app-custom-dropdown
                  [label]="'Load Condition'"
                  [controlname]="requestForm.controls['loadCondition']"
                  [items]="loadConditionOptions"
                  [formSubmitted]="formSubmitted"
                  [required]="isLoadConditionRequired"
                  [requiredErrorMessage]="'Load Condition is required'"
                ></app-custom-dropdown>
              </div>
              <div class="col-md-6">
                <app-custom-dropdown
                  [label]="'Load State'"
                  [items]="loadStateOptions"
                  [controlname]="requestForm.controls['loadState']"
                  [formSubmitted]="formSubmitted"
                  [required]="isLoadStateRequired"
                  [requiredErrorMessage]="'Load State is required'"
                  [readonly]="isLoadStateDisabled"
                ></app-custom-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <app-custom-input
                  [label]="'Years To Date CO2 Emissions'"
                  [controlname]="requestForm.controls['yearToDateCo2Emissions']"
                  [formSubmitted]="formSubmitted"
                  [required]="isYearToDateRequired"
                ></app-custom-input>
              </div>
              <div class="col-md-6">
                <app-custom-input
                  [label]="'Years To Date Distance'"
                  [controlname]="requestForm.controls['yearToDateDistance']"
                  [formSubmitted]="formSubmitted"
                  [required]="isYearToDateRequired"
                ></app-custom-input>
              </div>
              <div
                *ngIf="requestForm.hasError('yearToDateMismatch')"
                style="color: red"
                class="errorMsg both"
              >
                Both Years To Date CO2 Emissions & Distance must be entered
                together.
              </div>
            </div>
            <div class="row" *ngIf="selectedType !== 'Instructed set speed'">
              <div class="col-md-6">
                <app-custom-input
                  [label]="'Hours Between Route Way Points'"
                  [controlname]="
                    requestForm.controls['hoursBetweenRouteWaypoints']
                  "
                  [formSubmitted]="formSubmitted"
                ></app-custom-input>
              </div>
              <div
                class="col-md-6"
                *ngIf="selectedType === 'Optimal set speed'"
              >
                <app-custom-input
                  [label]="'Min Hours Btwn Speed Changes'"
                  [controlname]="
                    requestForm.controls['minimumHoursBetweenSpeedChanges']
                  "
                  [formSubmitted]="formSubmitted"
                ></app-custom-input>
              </div>
            </div>
          </div>

          <div class="commonFields">
            <p class="title" (click)="toggleFuelCurve()">
              Fuel Curve
              <span class="arrow">{{ fuelCurveOpen ? "▲" : "▼" }}</span>
            </p>
            <div *ngIf="fuelCurveOpen" class="fields">
              <div class="row">
                <div class="col-md-12">
                  <app-custom-input
                    [label]="'Other Fuel Consumption'"
                    [controlname]="requestForm.controls['otherFuelConsumption']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Fuel Usage 1'"
                    [controlname]="
                      requestForm.controls['fuelCurveFuelUsageOne']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Speed 1'"
                    [controlname]="requestForm.controls['fuelCurveSpeedOne']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Fuel Usage 2'"
                    [controlname]="
                      requestForm.controls['fuelCurveFuelUsageTwo']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Speed 2'"
                    [controlname]="requestForm.controls['fuelCurveSpeedTwo']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
            </div>
          </div>

          <div class="otherFields">
            <p class="title" (click)="togglePowerCurve()">
              Power Curve
              <span class="arrow">{{ powerCurveOpen ? "▲" : "▼" }}</span>
            </p>
            <div *ngIf="powerCurveOpen" class="fields">
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Speed 1'"
                    [controlname]="requestForm.controls['powerCurveSpeedOne']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Max Continuous Rating 1'"
                    [controlname]="
                      requestForm.controls['powerCurveMaxContinuousRatingOne']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Speed 2'"
                    [controlname]="requestForm.controls['powerCurveSpeedTwo']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Max Continuous Rating 2'"
                    [controlname]="
                      requestForm.controls['powerCurveMaxContinuousRatingTwo']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
            </div>
          </div>
          <div class="commonFields">
            <p class="title" (click)="toggleRmpCurve()">
              RPM Curve
              <span class="arrow">{{ rmpCurveOpen ? "▲" : "▼" }}</span>
            </p>
            <div *ngIf="rmpCurveOpen" class="fields">
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Speed 1'"
                    [controlname]="requestForm.controls['rpmSpeedOne']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'RPM 1'"
                    [controlname]="requestForm.controls['rpmOne']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Speed 2'"
                    [controlname]="requestForm.controls['rpmSpeedTwo']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'RPM 1'"
                    [controlname]="requestForm.controls['rpmTwo']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
            </div>
          </div>
          <div class="otherFields">
            <p class="title" (click)="toggleSaftyMargin()">
              Safety Margins
              <span class="arrow">{{ saftyMarginOpen ? "▲" : "▼" }}</span>
            </p>
            <div *ngIf="saftyMarginOpen" class="fields">
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Port'"
                    [controlname]="requestForm.controls['safetyMarginsPort']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Starboard'"
                    [controlname]="
                      requestForm.controls['safetyMarginsStarboard']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Under Keel'"
                    [controlname]="requestForm.controls['underKeel']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Air'"
                    [controlname]="requestForm.controls['air']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Aft'"
                    [controlname]="requestForm.controls['aft']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Forward'"
                    [controlname]="requestForm.controls['forward']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
            </div>
          </div>
          <div class="commonFields">
            <p class="title" (click)="toggleCost()">
              Cost
              <span class="arrow">{{ costOpen ? "▲" : "▼" }}</span>
            </p>
            <div *ngIf="costOpen" class="fields">
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Vessel Cost'"
                    [controlname]="requestForm.controls['vesselCost']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Fuel Cost'"
                    [controlname]="requestForm.controls['fuelCost']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'ECA Fuel Cost'"
                    [controlname]="requestForm.controls['ecaFuelCost']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Other Fuel Cost'"
                    [controlname]="requestForm.controls['otherFuelCost']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
            </div>
          </div>
          <div class="otherFields">
            <p class="title" (click)="toggleRestrictions()">
              Restrictions
              <span class="arrow">{{ restrictionsOpen ? "▲" : "▼" }}</span>
            </p>

            <div *ngIf="restrictionsOpen" class="fields">
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'North Vertex'"
                    [controlname]="requestForm.controls['northVertex']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'South Vertex'"
                    [controlname]="requestForm.controls['southVertex']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Area Id'"
                    [controlname]="requestForm.controls['areaId']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Enabled'"
                    [controlname]="requestForm.controls['enabled']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Custom Areas-lat 1'"
                    [controlname]="requestForm.controls['custAreasLatOne']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Custom Areas-lon 1'"
                    [controlname]="requestForm.controls['custAreasLonOne']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Custom Areas-lat 2'"
                    [controlname]="requestForm.controls['custAreasLatTwo']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Custom Areas-lon 2'"
                    [controlname]="requestForm.controls['custAreasLonTwo']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Custom Areas-lat 3'"
                    [controlname]="requestForm.controls['custAreasLatThree']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Custom Areas-lon 3'"
                    [controlname]="requestForm.controls['custAreasLonThree']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Custom Areas-lat 2'"
                    [controlname]="requestForm.controls['custAreasLatFour']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Custom Areas-lon 2'"
                    [controlname]="requestForm.controls['custAreasLonFour']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Custom Areas-Name'"
                    [controlname]="requestForm.controls['custAreasName']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-dropdown
                    [label]="'Custom Areas-Type'"
                    [items]="customAreasTypeOptions"
                    [controlname]="requestForm.controls['custAreasType']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-dropdown>
                </div>
              </div>

              <div class="row">
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('custAreasType')?.value === 'Speed Limit'
                  "
                >
                  <app-custom-input
                    [label]="'Speed Limit'"
                    [controlname]="requestForm.controls['speedLimit']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('custAreasType')?.value ===
                    'Emission Control'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum emission allowed'"
                    [controlname]="requestForm.controls['maxEmissionAllowed']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('custAreasType')?.value ===
                    'Emission Control'
                  "
                >
                  <app-custom-dropdown
                    [label]="'Emission Type'"
                    [items]="emissionTypeOptions"
                    [controlname]="requestForm.controls['emissionType']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-dropdown>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <app-custom-dropdown
                    [label]="'Weather Limits-Name One'"
                    [items]="weatherLimitsNameOptions"
                    [controlname]="requestForm.controls['weatherLimitsNameOne']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-dropdown>
                </div>
              </div>

              <div class="row">
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Icing Risk'
                  "
                >
                  <app-custom-dropdown
                    [label]="'Maximum'"
                    [items]="icingRiskMaxOptions"
                    [controlname]="requestForm.controls['icingRiskMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-dropdown>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Visibility'
                  "
                >
                  <app-custom-dropdown
                    [label]="'Minimum'"
                    [items]="visibilityMinOptions"
                    [controlname]="requestForm.controls['visibilityMin']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-dropdown>
                </div>

                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Total Wave Height'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['totalWaveHeightMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>

                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Beam Waves Height'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['beamWaveHeightMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Following Waves Height'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="
                      requestForm.controls['followingWaveHeightMax']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Head Waves Height'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['headWaveHeightMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Risk Wave Height'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['riskWaveHeightMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Wind Speed 10m'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['windSpeedTenMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Wind Speed 50m'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['windSpeedFiftyMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Wind Gusts 10m'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['windGustsTenMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Wind Gusts 50m'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['windGustsFiftyMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Head Wind Speed'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['headWindSpeedMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Beam Wind Speed'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['beamWindSpeedMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Following Wind Speed'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="
                      requestForm.controls['followingWindSpeedMax']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Risk Wind Speed'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['riskWindSpeedMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Ice Concentration'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['iceConcentrationMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Hurricane Distance'
                  "
                >
                  <app-custom-input
                    [label]="'Minimum'"
                    [controlname]="requestForm.controls['hurricaneDistanceMin']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Tropical Storm Distance'
                  "
                >
                  <app-custom-input
                    [label]="'Minimum'"
                    [controlname]="
                      requestForm.controls['tropicalStormDistanceMin']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Tropical Depression Distance'
                  "
                >
                  <app-custom-input
                    [label]="'Minimum'"
                    [controlname]="
                      requestForm.controls['tropicalDepressionDistanceMin']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Beam Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['beamWavePeriodMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Beam Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Minimum'"
                    [controlname]="requestForm.controls['beamWavePeriodMin']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Following Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="
                      requestForm.controls['followingWavePeriodMax']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Following Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Minimum'"
                    [controlname]="
                      requestForm.controls['followingWavePeriodMin']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Head Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['headWavePeriodMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameOne')?.value ===
                    'Head Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Minimum'"
                    [controlname]="requestForm.controls['headWavePeriodMin']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row" *ngIf="isWeatherLimitsNameSelected">
                <div class="col-md-12">
                  <app-custom-input
                    [label]="'Weather Limits-Name Two'"
                    [controlname]="requestForm.controls['weatherLimitsNameTwo']"
                    [formSubmitted]="formSubmitted"
                    [readonly]="true"
                  ></app-custom-input>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameTwo')?.value ===
                    'Beam Waves Height'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['beamWaveHeightMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameTwo')?.value ===
                    'Following Waves Height'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="
                      requestForm.controls['followingWaveHeightMax']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameTwo')?.value ===
                    'Head Waves Height'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['headWaveHeightMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameTwo')?.value ===
                    'Beam Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['beamWavePeriodMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameTwo')?.value ===
                    'Beam Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Minimum'"
                    [controlname]="requestForm.controls['beamWavePeriodMin']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameTwo')?.value ===
                    'Following Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="
                      requestForm.controls['followingWavePeriodMax']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameTwo')?.value ===
                    'Following Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Minimum'"
                    [controlname]="
                      requestForm.controls['followingWavePeriodMin']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameTwo')?.value ===
                    'Head Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Maximum'"
                    [controlname]="requestForm.controls['headWavePeriodMax']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="
                    requestForm.get('weatherLimitsNameTwo')?.value ===
                    'Head Waves Period'
                  "
                >
                  <app-custom-input
                    [label]="'Minimum'"
                    [controlname]="requestForm.controls['headWavePeriodMin']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <app-custom-dropdown
                    [label]="'Weather Limits-Action type'"
                    [items]="weatherLimitsActionTypeOptions"
                    [controlname]="
                      requestForm.controls['weatherLimitsActionType']
                    "
                    [formSubmitted]="formSubmitted"
                  ></app-custom-dropdown>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-md-12"
                  *ngIf="
                    requestForm.get('weatherLimitsActionType')?.value === 'Warn'
                  "
                >
                  <app-custom-dropdown
                    [label]="'warning Severity'"
                    [items]="warningSeverityOptions"
                    [controlname]="requestForm.controls['warningSeverity']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="commonFields">
            <p class="title" (click)="toggleVoyage()">
              Voyage
              <span class="arrow">{{ voyageOpen ? "▲" : "▼" }}</span>
            </p>

            <div *ngIf="voyageOpen" class="fields">
              <div class="row">
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Ports - lat'"
                    [controlname]="requestForm.controls['portsLat']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    [label]="'Ports - lon'"
                    [controlname]="requestForm.controls['portsLon']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <app-custom-dropdown
                    [label]="'Weather Source'"
                    [items]="weatherSourceOptions"
                    [controlname]="requestForm.controls['weatherSource']"
                    [formSubmitted]="formSubmitted"
                  ></app-custom-dropdown>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="row">
            <div class="col-md-6"></div>
            <div class="col-md-6"></div>
          </div> -->
          <!-- add other fields like beam, length, etc. in same format -->
        </div>

        <div
          class="commonFields"
          *ngIf="
            selectedType === 'jupiter Route' ||
            (selectedType === 'Fixed ETA' && selectedTab === true)
          "
        >
          <!-- Premium single-route upload panel -->
          <div *ngIf="!isMultiRouteComp" class="route-upload-panel">
            <div class="route-upload-title">Route CSV Configuration</div>
            <div class="route-upload-item">
              <span class="text-xs text-slate-500 font-semibold"
                >CSV Route:</span
              >
              <span
                *ngIf="uploadedRoutePoints.length > 0"
                class="route-status-badge uploaded"
              >
                <mat-icon
                  style="
                    font-size: 14px;
                    width: 14px;
                    height: 14px;
                    margin-bottom: 0px !important;
                  "
                  >check_circle</mat-icon
                >
                Uploaded
              </span>
              <span
                *ngIf="uploadedRoutePoints.length === 0"
                class="route-status-badge required"
              >
                <mat-icon
                  style="
                    font-size: 14px;
                    width: 14px;
                    height: 14px;
                    margin-bottom: 0px !important;
                  "
                  >error_outline</mat-icon
                >
                CSV Required
              </span>
              <button
                type="button"
                class="route-action-btn"
                (click)="fileInput.click()"
                matTooltip="Upload CSV Route"
              >
                <mat-icon>cloud_upload</mat-icon>
              </button>
              <button
                *ngIf="uploadedRoutePoints.length > 0"
                type="button"
                class="route-clear-btn"
                (click)="clearRoute(0)"
                matTooltip="Clear Route"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <input
              type="file"
              #fileInput
              hidden
              (change)="onFileUpload($event)"
              accept=".csv, .xlsx, .xls"
            />
          </div>

          <!-- Premium multi-route upload panel -->
          <div *ngIf="isMultiRouteComp" class="route-upload-panel">
            <div class="route-upload-title">Route CSV Configurations</div>

            <div class="d-flex align-items-center gap-3 flex-wrap">
              <!-- Route 1 Upload -->
              <div class="route-upload-item">
                <span class="text-xs text-slate-500 font-semibold"
                  >Route 1:</span
                >
                <span
                  *ngIf="uploadedRoutePoints1.length > 0"
                  class="route-status-badge uploaded"
                >
                  <mat-icon
                    style="
                      font-size: 14px;
                      width: 14px;
                      height: 14px;
                      margin-bottom: 0px !important;
                    "
                    >check_circle</mat-icon
                  >
                  Uploaded
                </span>
                <span
                  *ngIf="uploadedRoutePoints1.length === 0"
                  class="route-status-badge required"
                >
                  <mat-icon
                    style="
                      font-size: 14px;
                      width: 14px;
                      height: 14px;
                      margin-bottom: 0px !important;
                    "
                    >error_outline</mat-icon
                  >
                  CSV Required
                </span>
                <button
                  type="button"
                  class="route-action-btn"
                  (click)="route1Input.click()"
                  matTooltip="Upload Route 1 CSV"
                >
                  <mat-icon>cloud_upload</mat-icon>
                </button>
                <button
                  *ngIf="uploadedRoutePoints1.length > 0"
                  type="button"
                  class="route-clear-btn"
                  (click)="clearRoute(1)"
                  matTooltip="Clear Route 1"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <!-- Route 2 Upload -->
              <div class="route-upload-item">
                <span class="text-xs text-slate-500 font-semibold"
                  >Route 2:</span
                >
                <span
                  *ngIf="uploadedRoutePoints2.length > 0"
                  class="route-status-badge uploaded"
                >
                  <mat-icon
                    style="
                      font-size: 14px;
                      width: 14px;
                      height: 14px;
                      margin-bottom: 0px !important;
                    "
                    >check_circle</mat-icon
                  >
                  Ready
                </span>
                <span
                  *ngIf="uploadedRoutePoints2.length === 0"
                  class="route-status-badge required"
                >
                  <mat-icon
                    style="
                      font-size: 14px;
                      width: 14px;
                      height: 14px;
                      margin-bottom: 0px !important;
                    "
                    >error_outline</mat-icon
                  >
                  CSV Required
                </span>
                <button
                  type="button"
                  class="route-action-btn"
                  (click)="route2Input.click()"
                  matTooltip="Upload Route 2 CSV"
                >
                  <mat-icon>cloud_upload</mat-icon>
                </button>
                <button
                  *ngIf="uploadedRoutePoints2.length > 0"
                  type="button"
                  class="route-clear-btn"
                  (click)="clearRoute(2)"
                  matTooltip="Clear Route 2"
                >
                  <mat-icon>close</mat-icon>
                </button>

                <!-- "Same Route" button if Route 1 is uploaded but Route 2 is not -->
                <button
                  *ngIf="
                    uploadedRoutePoints1.length > 0 &&
                    uploadedRoutePoints2.length === 0
                  "
                  type="button"
                  class="same-route-btn"
                  (click)="useSameRouteForRoute2()"
                  matTooltip="Copy coordinates from Route 1 to Route 2"
                >
                  <mat-icon
                    style="
                      font-size: 14px;
                      width: 14px;
                      height: 14px;
                      margin-bottom: 0px !important;
                    "
                    >content_copy</mat-icon
                  >
                  Use Same Route
                </button>
              </div>
            </div>

            <input
              type="file"
              #route1Input
              hidden
              accept=".csv,.xlsx,.xls"
              (change)="onFileUpload($event, 1)"
            />

            <input
              type="file"
              #route2Input
              hidden
              accept=".csv,.xlsx,.xls"
              (change)="onFileUpload($event, 2)"
            />
          </div>

          <!-- Vessel -->
          <div class="row">
            <div class="col-md-6">
              <label class="shipNameLabel"
                ><span class="asterik-color">*</span>Vessel Name</label
              >
              <input
                type="text"
                class="form-control shipName"
                formControlName="vesselName"
                (input)="filterShipNames($event)"
                [matAutocomplete]="autoShipJupiter"
              />
              <mat-autocomplete #autoShipJupiter="matAutocomplete">
                <mat-option
                  *ngFor="let ship of shipNameSuggestions"
                  [value]="ship.vessel_name"
                >
                  {{ ship.vessel_name }}
                </mat-option>
              </mat-autocomplete>
            </div>

            <div class="col-md-6">
              <label class="shipNameLabel"
                ><span class="asterik-color">*</span>Vessel Type
              </label>
              <input
                type="text"
                formControlName="vesselType"
                [matAutocomplete]="autoVesselType"
                class="form-control"
              />

              <mat-autocomplete #autoVesselType="matAutocomplete">
                <mat-option
                  *ngFor="let option of filteredOptions"
                  [value]="option.label"
                >
                  {{ option.label }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <!-- IMO & Year -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="IMO"
                [controlname]="requestForm.controls['imo']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Year Built"
                [controlname]="requestForm.controls['yearBuilt']"
              ></app-custom-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label class="shipNameLabel"
                ><span class="asterik-color">*</span>Start Port Name
              </label>
              <input
                type="text"
                matInput
                formControlName="startPortName"
                [matAutocomplete]="auto"
                (input)="filterPorts()"
                required
                class="form-control"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onPortSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let port of filteredPorts"
                  [value]="port.properties.name"
                >
                  {{ port.properties.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'Start Port Id'"
                [controlname]="requestForm.controls['startPortId']"
                [errorMessage]="'Start lon is required'"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
          </div>
          <div class="row">
            <!-- <div
              class="col-md-1 viaPoint"
              [matTooltip]="'Add Via points'"
              (click)="addViaPoint()"
            >
              <mat-icon>add_circle</mat-icon>
            </div> -->
            <div class="col-md-6">
              <app-custom-input
                [label]="'Start Latitude'"
                [controlname]="requestForm.controls['startLat']"
                [errorMessage]="'Start lat is required'"
                [formSubmitted]="formSubmitted"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'Start Longitude'"
                [controlname]="requestForm.controls['startLon']"
                [errorMessage]="'Start lon is required'"
                [formSubmitted]="formSubmitted"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="myLocation">
              <mat-icon (click)="enableLocationSelect('startLat', 'startLon')"
                >my_location</mat-icon
              >
            </div>
          </div>
          <div class="row" *ngFor="let point of viaPoints; let i = index">
            <div class="col-md-1 viaPoint">
              <mat-icon
                *ngIf="i === viaPoints.length - 1"
                matTooltip="Add Via point"
                class="text-success cursor-pointer viaPointIcon"
                (click)="addViaPoint()"
                >add_circle</mat-icon
              >

              <mat-icon
                *ngIf="viaPoints.length > 1"
                matTooltip="Remove Via point"
                class="text-danger cursor-pointer"
                (click)="removeViaPoint(i)"
                >remove_circle</mat-icon
              >
            </div>

            <div class="col-md-5">
              <app-custom-input
                [label]="'Via Point Lat' + (i + 1)"
                [controlname]="requestForm.controls[point.lat]"
                [errorMessage]="'Latitude is required'"
                [formSubmitted]="formSubmitted"
              ></app-custom-input>
            </div>

            <div class="col-md-6">
              <app-custom-input
                [label]="'Via Point Lon' + (i + 1)"
                [controlname]="requestForm.controls[point.lon]"
                [errorMessage]="'Longitude is required'"
                [formSubmitted]="formSubmitted"
              ></app-custom-input>
            </div>

            <div class="myLocation">
              <mat-icon
                (click)="enableLocationSelect(point.lat, point.lon)"
                class="cursor-pointer"
                >my_location</mat-icon
              >
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label class="shipNameLabel">
                <span class="asterik-color">*</span>End Port Name
              </label>
              <input
                type="text"
                class="form-control portName"
                id="endPortName"
                formControlName="endPortName"
                (input)="filterEndPorts()"
                [matAutocomplete]="autoEndPort"
                required
              />
              <mat-autocomplete
                #autoEndPort="matAutocomplete"
                (optionSelected)="onEndPortSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let port of filteredEndPorts"
                  [value]="port.properties.name"
                >
                  {{ port.properties.name }}
                </mat-option>
              </mat-autocomplete>

              <div
                *ngIf="
                  formSubmitted && requestForm.controls['endPortName'].invalid
                "
                style="color: red"
                class="errorMsg"
              >
                End Port name is required.
              </div>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'End Port ID'"
                [controlname]="requestForm.controls['endPortId']"
                [errorMessage]="'Port ID is required'"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [label]="'End Latitude'"
                [controlname]="requestForm.controls['endLat']"
                [errorMessage]="'End lat is required'"
                [formSubmitted]="formSubmitted"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'End Longitude'"
                [controlname]="requestForm.controls['endLon']"
                [formSubmitted]="formSubmitted"
                [errorMessage]="'End lon is required'"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="myLocation">
              <mat-icon (click)="enableLocationSelect('endLat', 'endLon')"
                >my_location</mat-icon
              >
            </div>
          </div>
          <!-- Route Config -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Time Between Points (hrs)"
                [controlname]="requestForm.controls['timeBetwPoints']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-dropdown
                [label]="'Condition'"
                [items]="conditionOptions"
                [controlname]="requestForm.controls['condition']"
              ></app-custom-dropdown>
            </div>
          </div>
          <div class="row" *ngIf="!isRouteComp && !isMultiRouteComp">
            <div class="col-md-6">
              <app-custom-input
                label="Speed (knots)"
                [controlname]="requestForm.controls['speed']"
              >
              </app-custom-input>
            </div>

            <div class="col-md-6">
              <app-custom-input
                label="Consumption (MT)"
                [controlname]="requestForm.controls['consumption']"
              >
              </app-custom-input>
            </div>

            <div class="col-md-6">
              <app-custom-input
                label="Fuel Cost per MT"
                [controlname]="requestForm.controls['fuel_cost_per_mt']"
              >
              </app-custom-input>
            </div>

            <div class="col-md-6">
              <app-custom-input
                label="Vessel Cost per Day"
                [controlname]="requestForm.controls['vessel_cost_per_day']"
              >
              </app-custom-input>
            </div>
          </div>

          <!-- Route Comparison -->
          <div
            *ngIf="isRouteComp || isMultiRouteComp"
            formArrayName="routeComparisons"
          >
            <div
              *ngFor="let group of routeComparisons.controls; let i = index"
              [formGroupName]="i"
              class="mb-3 p-3 bg-light border rounded"
            >
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <span style="color: #696868; font-size: 13px; font-weight: 600"
                  >Option {{ i + 1 }}</span
                >
                <div class="d-flex align-items-center">
                  <mat-icon
                    *ngIf="i > 0"
                    class="speed-icon remove-icon ms-2"
                    style="margin-top: 0"
                    (click)="removeRouteComparison(i)"
                  >
                    remove_circle
                  </mat-icon>
                  <mat-icon
                    *ngIf="i === routeComparisons.length - 1"
                    class="speed-icon add-icon ms-2"
                    style="margin-top: 0"
                    (click)="addRouteComparison()"
                  >
                    add_circle
                  </mat-icon>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-2">
                  <app-custom-input
                    label="Speed"
                    [controlname]="group.get('speed')"
                  >
                  </app-custom-input>
                </div>
                <div class="col-md-6 mb-2">
                  <app-custom-input
                    label="Consumption"
                    [controlname]="group.get('consumption')"
                  >
                  </app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    label="Fuel/MT"
                    [controlname]="group.get('fuel_cost_per_mt')"
                  >
                  </app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    label="Vessel/Day"
                    [controlname]="group.get('vessel_cost_per_day')"
                  >
                  </app-custom-input>
                </div>
              </div>
            </div>
          </div>
          <!-- Weather -->
          <!-- <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Weather Forecast Range"
                [controlname]="requestForm.controls['weatherForcRange']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Time Back In Hours"
                [controlname]="requestForm.controls['timeBckInHours']"
              ></app-custom-input>
            </div>
          </div> -->

          <!-- Ship Details (NEW) -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Ship Length"
                [controlname]="requestForm.controls['ship_length']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Ship Breadth"
                [controlname]="requestForm.controls['ship_breadth']"
              ></app-custom-input>
            </div>
          </div>

          <!-- Wind & Physics -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Wind Drag Coefficient"
                [controlname]="requestForm.controls['wind_drag_coefficient']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Air Density"
                [controlname]="requestForm.controls['air_density']"
              ></app-custom-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Empirical Constant"
                [controlname]="requestForm.controls['empirical_constant']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Power Input"
                [controlname]="requestForm.controls['power_inp']"
              ></app-custom-input>
            </div>
          </div>

          <!-- Departure -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Windage Area"
                [controlname]="requestForm.controls['windage_area']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Departure Time"
                [controlname]="requestForm.controls['etd']"
              ></app-custom-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [type]="'date'"
                [label]="'Estimated Time of Departure(UTC)'"
                [controlname]="requestForm.controls['etdDate']"
                [errorMessage]="'This is required'"
                [formSubmitted]="formSubmitted"
                [errorMessage]="'ETD is required'"
                [required]="true"
              ></app-custom-input>
            </div>
            <div class="col-md-3">
              <app-custom-input
                [type]="'number'"
                [label]="'Hours'"
                [controlname]="requestForm.controls['etdHours']"
                [errorMessage]="'This is required'"
                [formSubmitted]="formSubmitted"
                [errorMessage]="'ETD is required'"
                [required]="true"
              ></app-custom-input>
            </div>
            <div class="col-md-3">
              <app-custom-input
                [type]="'number'"
                [label]="'Minutes'"
                [controlname]="requestForm.controls['etdMinutes']"
                [errorMessage]="'This is required'"
                [formSubmitted]="formSubmitted"
                [errorMessage]="'ETD is required'"
                [required]="true"
              ></app-custom-input>
            </div>
          </div>
          <div
            class="row"
            *ngIf="selectedType === 'Fixed ETA' && selectedTab === true"
          >
            <div class="col-md-6">
              <app-custom-input
                [type]="'date'"
                [label]="'Estimated Time of Arrival'"
                [controlname]="requestForm.controls['etaDate']"
                [formSubmitted]="formSubmitted"
                [errorMessage]="'ETA is required'"
                [required]="true"
              >
              </app-custom-input>
            </div>

            <div class="col-md-3">
              <app-custom-input
                [type]="'number'"
                [label]="'Hours'"
                [controlname]="requestForm.controls['etahours']"
                [formSubmitted]="formSubmitted"
                [required]="true"
              >
              </app-custom-input>
            </div>

            <div class="col-md-3">
              <app-custom-input
                [type]="'number'"
                [label]="'Minutes'"
                [controlname]="requestForm.controls['etaMinutes']"
                [formSubmitted]="formSubmitted"
                [required]="true"
              >
              </app-custom-input>
            </div>
          </div>
          <div
            class="row"
            *ngIf="selectedType === 'Fixed ETA' && selectedTab === true"
          >
            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Max Speed'"
                [controlname]="requestForm.controls['maxSpeed']"
              >
              </app-custom-input>
            </div>

            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Min Speed'"
                [controlname]="requestForm.controls['minSpeed']"
              >
              </app-custom-input>
            </div>
          </div>

          <div
            class="row mt-3"
            *ngIf="selectedType === 'Fixed ETA' && selectedTab === true"
          >
            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Rough Wave Height'"
                [controlname]="requestForm.controls['rough_wave_h']"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Rough Wind Speed'"
                [controlname]="requestForm.controls['rough_wind_spd']"
              >
              </app-custom-input>
            </div>
          </div>
          <div
            class="row mt-3"
            *ngIf="selectedType === 'Fixed ETA' && selectedTab === true"
          >
            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Moderate Wave Height'"
                [controlname]="requestForm.controls['moderate_wave_h']"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Moderate Wind'"
                [controlname]="requestForm.controls['moderate_wind']"
              >
              </app-custom-input>
            </div>
          </div>
        </div>
        <div
          class="commonFields"
          *ngIf="selectedType === 'Optimal set speed' && selectedTab === true"
        >
          <!-- Premium single-route upload panel -->
          <div *ngIf="!isMultiRouteComp" class="route-upload-panel">
            <div class="route-upload-title">Route CSV Configuration</div>
            <div class="route-upload-item">
              <span class="text-xs text-slate-500 font-semibold"
                >CSV Route:</span
              >
              <span
                *ngIf="uploadedRoutePoints.length > 0"
                class="route-status-badge uploaded"
              >
                <mat-icon
                  style="
                    font-size: 14px;
                    width: 14px;
                    height: 14px;
                    margin-bottom: 0px !important;
                  "
                  >check_circle</mat-icon
                >
                Uploaded
              </span>
              <span
                *ngIf="uploadedRoutePoints.length === 0"
                class="route-status-badge required"
              >
                <mat-icon
                  style="
                    font-size: 14px;
                    width: 14px;
                    height: 14px;
                    margin-bottom: 0px !important;
                  "
                  >error_outline</mat-icon
                >
                CSV Required
              </span>
              <button
                type="button"
                class="route-action-btn"
                (click)="fileInput.click()"
                matTooltip="Upload CSV Route"
              >
                <mat-icon>cloud_upload</mat-icon>
              </button>
              <button
                *ngIf="uploadedRoutePoints.length > 0"
                type="button"
                class="route-clear-btn"
                (click)="clearRoute(0)"
                matTooltip="Clear Route"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <input
              type="file"
              #fileInput
              hidden
              (change)="onFileUpload($event)"
              accept=".csv, .xlsx, .xls"
            />
          </div>
          <!-- Vessel -->
          <div class="row">
            <div class="col-md-6">
              <label class="shipNameLabel"
                ><span class="asterik-color">*</span>Vessel Name</label
              >
              <input
                type="text"
                class="form-control shipName"
                formControlName="vesselName"
                (input)="filterShipNames($event)"
                [matAutocomplete]="autoShipJupiter"
              />
              <mat-autocomplete #autoShipJupiter="matAutocomplete">
                <mat-option
                  *ngFor="let ship of shipNameSuggestions"
                  [value]="ship.vessel_name"
                >
                  {{ ship.vessel_name }}
                </mat-option>
              </mat-autocomplete>
            </div>

            <div class="col-md-6">
              <label class="shipNameLabel"
                ><span class="asterik-color">*</span>Vessel Type
              </label>
              <input
                type="text"
                formControlName="vesselType"
                [matAutocomplete]="autoVesselType"
                class="form-control"
              />

              <mat-autocomplete #autoVesselType="matAutocomplete">
                <mat-option
                  *ngFor="let option of filteredOptions"
                  [value]="option.label"
                >
                  {{ option.label }}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <!-- IMO & Year -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="IMO"
                [controlname]="requestForm.controls['imo']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Year Built"
                [controlname]="requestForm.controls['yearBuilt']"
              ></app-custom-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label class="shipNameLabel"
                ><span class="asterik-color">*</span>Start Port Name
              </label>
              <input
                type="text"
                matInput
                formControlName="startPortName"
                [matAutocomplete]="auto"
                (input)="filterPorts()"
                required
                class="form-control"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onPortSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let port of filteredPorts"
                  [value]="port.properties.name"
                >
                  {{ port.properties.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'Start Port Id'"
                [controlname]="requestForm.controls['startPortId']"
                [errorMessage]="'Start lon is required'"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
          </div>
          <div class="row">
            <!-- <div
              class="col-md-1 viaPoint"
              [matTooltip]="'Add Via points'"
              (click)="addViaPoint()"
            >
              <mat-icon>add_circle</mat-icon>
            </div> -->
            <div class="col-md-6">
              <app-custom-input
                [label]="'Start Latitude'"
                [controlname]="requestForm.controls['startLat']"
                [errorMessage]="'Start lat is required'"
                [formSubmitted]="formSubmitted"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'Start Longitude'"
                [controlname]="requestForm.controls['startLon']"
                [errorMessage]="'Start lon is required'"
                [formSubmitted]="formSubmitted"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="myLocation">
              <mat-icon (click)="enableLocationSelect('startLat', 'startLon')"
                >my_location</mat-icon
              >
            </div>
          </div>
          <div class="row" *ngFor="let point of viaPoints; let i = index">
            <div class="col-md-1 viaPoint">
              <mat-icon
                *ngIf="i === viaPoints.length - 1"
                matTooltip="Add Via point"
                class="text-success cursor-pointer viaPointIcon"
                (click)="addViaPoint()"
                >add_circle</mat-icon
              >

              <mat-icon
                *ngIf="viaPoints.length > 1"
                matTooltip="Remove Via point"
                class="text-danger cursor-pointer"
                (click)="removeViaPoint(i)"
                >remove_circle</mat-icon
              >
            </div>

            <div class="col-md-5">
              <app-custom-input
                [label]="'Via Point Lat' + (i + 1)"
                [controlname]="requestForm.controls[point.lat]"
                [errorMessage]="'Latitude is required'"
                [formSubmitted]="formSubmitted"
              ></app-custom-input>
            </div>

            <div class="col-md-6">
              <app-custom-input
                [label]="'Via Point Lon' + (i + 1)"
                [controlname]="requestForm.controls[point.lon]"
                [errorMessage]="'Longitude is required'"
                [formSubmitted]="formSubmitted"
              ></app-custom-input>
            </div>

            <div class="myLocation">
              <mat-icon
                (click)="enableLocationSelect(point.lat, point.lon)"
                class="cursor-pointer"
                >my_location</mat-icon
              >
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label class="shipNameLabel">
                <span class="asterik-color">*</span>End Port Name
              </label>
              <input
                type="text"
                class="form-control portName"
                id="endPortName"
                formControlName="endPortName"
                (input)="filterEndPorts()"
                [matAutocomplete]="autoEndPort"
                required
              />
              <mat-autocomplete
                #autoEndPort="matAutocomplete"
                (optionSelected)="onEndPortSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let port of filteredEndPorts"
                  [value]="port.properties.name"
                >
                  {{ port.properties.name }}
                </mat-option>
              </mat-autocomplete>

              <div
                *ngIf="
                  formSubmitted && requestForm.controls['endPortName'].invalid
                "
                style="color: red"
                class="errorMsg"
              >
                End Port name is required.
              </div>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'End Port ID'"
                [controlname]="requestForm.controls['endPortId']"
                [errorMessage]="'Port ID is required'"
                [formSubmitted]="formSubmitted"
              >
              </app-custom-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [label]="'End Latitude'"
                [controlname]="requestForm.controls['endLat']"
                [errorMessage]="'End lat is required'"
                [formSubmitted]="formSubmitted"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'End Longitude'"
                [controlname]="requestForm.controls['endLon']"
                [formSubmitted]="formSubmitted"
                [errorMessage]="'End lon is required'"
                [required]="true"
              >
              </app-custom-input>
            </div>
            <div class="myLocation">
              <mat-icon (click)="enableLocationSelect('endLat', 'endLon')"
                >my_location</mat-icon
              >
            </div>
          </div>
          <!-- Route Config -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Time Between Points (hrs)"
                [controlname]="requestForm.controls['timeBetwPoints']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-dropdown
                [label]="'Condition'"
                [items]="conditionOptions"
                [controlname]="requestForm.controls['condition']"
              ></app-custom-dropdown>
            </div>
          </div>
          <!-- Route Comparison -->
          <div
            *ngIf="isRouteComp || isMultiRouteComp"
            formArrayName="routeComparisons"
          >
            <div
              *ngFor="let group of routeComparisons.controls; let i = index"
              [formGroupName]="i"
              class="mb-3 p-3 bg-light border rounded"
            >
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <span style="color: #696868; font-size: 13px; font-weight: 600"
                  >Option {{ i + 1 }}</span
                >
                <div class="d-flex align-items-center">
                  <mat-icon
                    *ngIf="i > 0"
                    class="speed-icon remove-icon ms-2"
                    style="margin-top: 0"
                    (click)="removeRouteComparison(i)"
                  >
                    remove_circle
                  </mat-icon>
                  <mat-icon
                    *ngIf="i === routeComparisons.length - 1"
                    class="speed-icon add-icon ms-2"
                    style="margin-top: 0"
                    (click)="addRouteComparison()"
                  >
                    add_circle
                  </mat-icon>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-2">
                  <app-custom-input
                    label="Speed"
                    [controlname]="group.get('speed')"
                  >
                  </app-custom-input>
                </div>
                <div class="col-md-6 mb-2">
                  <app-custom-input
                    label="Consumption"
                    [controlname]="group.get('consumption')"
                  >
                  </app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    label="Fuel/MT"
                    [controlname]="group.get('fuel_cost_per_mt')"
                  >
                  </app-custom-input>
                </div>
                <div class="col-md-6">
                  <app-custom-input
                    label="Vessel/Day"
                    [controlname]="group.get('vessel_cost_per_day')"
                  >
                  </app-custom-input>
                </div>
              </div>
            </div>
          </div>
          <!-- Weather -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Stop Wind"
                [controlname]="requestForm.controls['stop_wind_kn']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Stop Fuel Rate"
                [controlname]="requestForm.controls['stop_fuel_rate']"
              ></app-custom-input>
            </div>
          </div>

          <!-- Where she is when the plan starts.
               It sits with Stop Wind and Stop Fuel Rate because it changes
               what those two mean: alongside, a hold at the first waypoint is
               free, uncapped and never checked for weather; at sea the same
               hold burns stop fuel, is capped at 24 h, is checked, and she
               drifts with the current while she lies there. -->
          <div class="row">
            <div class="col-md-6">
              <label
                class="at-sea-check"
                [class.checked]="isAtSea()"
              >
                <input type="checkbox" formControlName="vesselAtSea" />
                <span class="at-sea-text">
                  <span class="at-sea-title">Vessel is already at sea</span>
                  <span class="at-sea-desc">
                    Leave unticked if she is alongside at the first waypoint.
                  </span>
                </span>
              </label>
            </div>
            <!-- Only means anything at sea: a vessel at a berth does not
                 drift, so showing the field alongside invites someone to set
                 a number that is then ignored. -->
            <div class="col-md-6" *ngIf="isAtSea()">
              <app-custom-input
                label="Drift Radius (nm)"
                [controlname]="requestForm.controls['driftRadiusNm']"
              ></app-custom-input>
            </div>
          </div>

          <!-- Ship Details (NEW) -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Ship Length"
                [controlname]="requestForm.controls['ship_length']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Ship Breadth"
                [controlname]="requestForm.controls['ship_breadth']"
              ></app-custom-input>
            </div>
          </div>

          <!-- Wind & Physics -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Wind Drag Coefficient"
                [controlname]="requestForm.controls['wind_drag_coefficient']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Air Density"
                [controlname]="requestForm.controls['air_density']"
              ></app-custom-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Empirical Constant"
                [controlname]="requestForm.controls['empirical_constant']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Power Input"
                [controlname]="requestForm.controls['power_inp']"
              ></app-custom-input>
            </div>
          </div>

          <!-- Departure -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Windage Area"
                [controlname]="requestForm.controls['windage_area']"
              ></app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Departure Time"
                [controlname]="requestForm.controls['etd']"
              ></app-custom-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                [type]="'date'"
                [label]="'Estimated Time of Departure(UTC)'"
                [controlname]="requestForm.controls['etdDate']"
                [errorMessage]="'This is required'"
                [formSubmitted]="formSubmitted"
                [errorMessage]="'ETD is required'"
                [required]="true"
              ></app-custom-input>
            </div>
            <div class="col-md-3">
              <app-custom-input
                [type]="'number'"
                [label]="'Hours'"
                [controlname]="requestForm.controls['etdHours']"
                [errorMessage]="'This is required'"
                [formSubmitted]="formSubmitted"
                [errorMessage]="'ETD is required'"
                [required]="true"
              ></app-custom-input>
            </div>
            <div class="col-md-3">
              <app-custom-input
                [type]="'number'"
                [label]="'Minutes'"
                [controlname]="requestForm.controls['etdMinutes']"
                [errorMessage]="'This is required'"
                [formSubmitted]="formSubmitted"
                [errorMessage]="'ETD is required'"
                [required]="true"
              ></app-custom-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Fuel Cost per MT"
                [controlname]="requestForm.controls['fuel_cost_per_mt']"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Hire Cost per Day"
                [controlname]="requestForm.controls['hire_cost_per_day']"
              >
              </app-custom-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="Wait Hours"
                [controlname]="requestForm.controls['wait_hours']"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="Strom BF"
                [controlname]="requestForm.controls['strom_BF']"
              >
              </app-custom-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="FC speed 1"
                [controlname]="requestForm.controls['fc_speed1']"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="FC Consumption 1"
                [controlname]="requestForm.controls['fc_consumption1']"
              >
              </app-custom-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-custom-input
                label="FC speed 2"
                [controlname]="requestForm.controls['fc_speed2']"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                label="FC Consumption 2"
                [controlname]="requestForm.controls['fc_consumption2']"
              >
              </app-custom-input>
            </div>
          </div>

          <!-- Fuel model. "Vessel fuel model" uses her own consumption at
               each speed, draft and weather when she has one (else the FC
               pairs above); "FC speed/consumption pairs" always uses the
               pairs. Draft blank = her draft for the Condition.
               The fuel model method is not shown: the form always sends
               "Performance screen (3M calibrated)" (calmWaterMethod control). -->
          <div class="row">
            <div class="col-md-6">
              <app-custom-dropdown
                [label]="'Consumption From'"
                [items]="fuelSourceOptions"
                [controlname]="requestForm.controls['fuelSource']"
              ></app-custom-dropdown>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                label="Draft (m)"
                [controlname]="requestForm.controls['draft']"
              >
              </app-custom-input>
            </div>
          </div>

          <div
            class="row"
            *ngIf="selectedType === 'Optimal set speed' && selectedTab === true"
          >
            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Max Speed'"
                [controlname]="requestForm.controls['maxSpeed']"
              >
              </app-custom-input>
            </div>

            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Min Speed'"
                [controlname]="requestForm.controls['minSpeed']"
              >
              </app-custom-input>
            </div>
          </div>

          <div
            class="row mt-3"
            *ngIf="selectedType === 'Optimal set speed' && selectedTab === true"
          >
            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Rough Wave Height'"
                [controlname]="requestForm.controls['rough_wave_h']"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Rough Wind Speed'"
                [controlname]="requestForm.controls['rough_wind_spd']"
              >
              </app-custom-input>
            </div>
          </div>
          <div
            class="row mt-3"
            *ngIf="selectedType === 'Optimal set speed' && selectedTab === true"
          >
            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Moderate Wave Height'"
                [controlname]="requestForm.controls['moderate_wave_h']"
              >
              </app-custom-input>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [type]="'number'"
                [label]="'Moderate Wind'"
                [controlname]="requestForm.controls['moderate_wind']"
              >
              </app-custom-input>
            </div>
          </div>
        </div>
        <div class="commonFields" *ngIf="selectedType === 'Upload Route'">
          <h3 class="FieldsText">Fields</h3>
          <div class="upload-section d-flex justify-content-end mb-2">
            <input
              type="file"
              #fileInput
              hidden
              (change)="onFileUpload($event)"
              accept=".csv, .xlsx, .xls"
            />
            <div class="uploadIcon">
              <mat-icon
                class="upload-icon ml-2"
                matTooltip="Upload CSV/Excel"
                (click)="fileInput.click()"
              >
                cloud_upload
              </mat-icon>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label class="shipNameLabel"
                ><span class="asterik-color"></span>Vessel Name
              </label>
              <input
                type="text"
                class="form-control shipName"
                id="shipName"
                formControlName="vesselName"
                (input)="filterShipNames($event)"
                [matAutocomplete]="autoShipUpload"
              />
              <mat-autocomplete #autoShipUpload="matAutocomplete">
                <mat-option
                  *ngFor="let ship of shipNameSuggestions"
                  [value]="ship.vessel_name"
                >
                  {{ ship.vessel_name }}
                </mat-option>
              </mat-autocomplete>
              <div
                *ngIf="
                  formSubmitted && requestForm.controls['vesselName'].invalid
                "
                style="color: red"
                class="errorMsg"
              >
                Vessel name is required
              </div>
            </div>
            <div class="col-md-6">
              <app-custom-input
                [label]="'IMO'"
                [controlname]="requestForm.controls['imo']"
                [errorMessage]="'IMO is required'"
                [formSubmitted]="formSubmitted"
              ></app-custom-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label class="shipNameLabel"
                ><span class="asterik-color"></span>Start Port Name
              </label>
              <input
                type="text"
                matInput
                formControlName="startPortName"
                [matAutocomplete]="auto"
                (input)="filterPorts()"
                required
                class="form-control"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onPortSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let port of filteredPorts"
                  [value]="port.properties.name"
                >
                  {{ port.properties.name }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-md-6">
              <label class="shipNameLabel">
                <span class="asterik-color"></span>End Port Name
              </label>
              <input
                type="text"
                class="form-control portName"
                id="endPortName"
                formControlName="endPortName"
                (input)="filterEndPorts()"
                [matAutocomplete]="autoEndPort"
                required
              />
              <mat-autocomplete
                #autoEndPort="matAutocomplete"
                (optionSelected)="onEndPortSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let port of filteredEndPorts"
                  [value]="port.properties.name"
                >
                  {{ port.properties.name }}
                </mat-option>
              </mat-autocomplete>

              <div
                *ngIf="
                  formSubmitted && requestForm.controls['endPortName'].invalid
                "
                style="color: red"
                class="errorMsg"
              >
                End Port name is required.
              </div>
            </div>
          </div>
        </div>
      </form>
      <div
        class="route-card-container mt-3"
        *ngIf="isMultiRouteComp && uploadedRoutePoints1.length > 0"
      >
        <div class="route-section-header">
          <h3 class="mb-0">Route 1 Points</h3>

          <button
            type="button"
            class="route-expand-btn"
            (click)="toggleRoute1Points()"
            [matTooltip]="
              route1PointsExpanded
                ? 'Collapse Route 1 Points'
                : 'Expand Route 1 Points'
            "
          >
            <mat-icon>
              {{ route1PointsExpanded ? "expand_less" : "expand_more" }}
            </mat-icon>
          </button>
        </div>
        <div *ngIf="route1PointsExpanded">
          <!-- Stats Banners -->
          <div
            class="route-header-summary d-flex gap-2 align-items-center mb-3 flex-wrap"
          >
            <div class="stats-badge secondary">
              <span class="badge-label">Waypoints</span>
              <span class="badge-value">{{ uploadedRoutePoints1.length }}</span>
            </div>
            <div class="stats-badge primary">
              <span class="badge-label">Total Distance</span>
              <span class="badge-value"
                >{{ getRouteDistance(uploadedRoutePoints1) }} NM</span
              >
            </div>
          </div>

          <div
            [id]="'route1-card-' + i"
            class="route-card route-1-card mb-3"
            [class.highlighted-card]="highlightedCardId === 'route1-card-' + i"
            [class.hovered-card]="hoveredCardId === 'route1-card-' + i"
            (mouseenter)="onCardMouseEnter(1, i)"
            (mouseleave)="onCardMouseLeave(1, i)"
            *ngFor="let point of uploadedRoutePoints1; let i = index"
          >
            <!-- Header -->
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h5 class="mb-0 font-semibold text-sm">
                Waypoint {{ point.WPT_No }}
              </h5>

              <div class="d-flex align-items-center">
                <mat-icon
                  matTooltip="Locate on Map"
                  class="text-primary cursor-pointer me-2"
                  style="font-size: 16px; width: 16px; height: 16px"
                  (click)="panToWaypointCard(point)"
                >
                  location_searching
                </mat-icon>

                <mat-icon
                  matTooltip="Add Waypoint"
                  class="text-success cursor-pointer me-2"
                  style="font-size: 16px; width: 16px; height: 16px"
                  (click)="addRow(i, uploadedRoutePoints1)"
                >
                  add_circle
                </mat-icon>

                <mat-icon
                  *ngIf="point.isAdded"
                  matTooltip="Remove Waypoint"
                  class="text-danger cursor-pointer"
                  style="font-size: 16px; width: 16px; height: 16px"
                  (click)="removeRow(i, uploadedRoutePoints1)"
                >
                  remove_circle
                </mat-icon>
              </div>
            </div>

            <!-- Compact Fields -->
            <div class="row g-2 align-items-end">
              <div class="col-4">
                <label class="compact-label">Latitude</label>
                <input
                  type="number"
                  class="form-control compact-input"
                  [(ngModel)]="point.LAT"
                  (change)="
                    recalculateWaypointDistances(uploadedRoutePoints1);
                    drawUploadedRoute(uploadedRoutePoints1)
                  "
                />
              </div>

              <div class="col-4">
                <label class="compact-label">Longitude</label>
                <div class="input-group input-group-sm">
                  <input
                    type="number"
                    class="form-control compact-input"
                    style="
                      border-top-right-radius: 0;
                      border-bottom-right-radius: 0;
                    "
                    [(ngModel)]="point.LONG"
                    (change)="
                      recalculateWaypointDistances(uploadedRoutePoints1);
                      drawUploadedRoute(uploadedRoutePoints1)
                    "
                  />
                  <span
                    *ngIf="point.isAdded"
                    class="input-group-text p-1 cursor-pointer bg-white"
                    style="
                      border-top-left-radius: 0;
                      border-bottom-left-radius: 0;
                    "
                    (click)="
                      enableWaypointLocationSelect(point, uploadedRoutePoints1)
                    "
                    matTooltip="Pick location from map"
                  >
                    <mat-icon style="font-size: 14px; width: 14px; height: 14px"
                      >my_location</mat-icon
                    >
                  </span>
                </div>
              </div>

              <div class="col-4">
                <label class="compact-label">Sail</label>
                <select
                  class="form-select form-control compact-input"
                  [(ngModel)]="point['Sail(RL/GC)']"
                  (change)="
                    recalculateWaypointDistances(uploadedRoutePoints1);
                    drawUploadedRoute(uploadedRoutePoints1)
                  "
                >
                  <option value="RL">RL</option>
                  <option value="GC">GC</option>
                </select>
              </div>
            </div>

            <!-- Compact Stats Footer -->
            <div class="card-footer-stats">
              <div class="leg-info">
                Leg:
                <b>{{
                  (point["Sail(RL/GC)"] === "GC"
                    ? point.GC_Distance_NM
                    : point.RL_Distance_NM) || 0
                }}</b>
                NM
                <span class="text-slate-400 font-normal">
                  (GC: {{ point.GC_Distance_NM || 0 }} / RL:
                  {{ point.RL_Distance_NM || 0 }})</span
                >
              </div>
              <div class="total-info">
                Total: {{ point.Total_Distance_NM || 0 }} NM
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="route-card-container mt-3"
        *ngIf="isMultiRouteComp && uploadedRoutePoints2.length > 0"
      >
        <div class="route-section-header">
          <h3 class="mb-0">Route 2 Points</h3>

          <button
            type="button"
            class="route-expand-btn"
            (click)="toggleRoute2Points()"
            [matTooltip]="
              route2PointsExpanded
                ? 'Collapse Route 2 Points'
                : 'Expand Route 2 Points'
            "
          >
            <mat-icon>
              {{ route2PointsExpanded ? "expand_less" : "expand_more" }}
            </mat-icon>
          </button>
        </div>

        <div *ngIf="route2PointsExpanded">
          <!-- Stats Banners -->
          <div
            class="route-header-summary d-flex gap-2 align-items-center mb-3 flex-wrap"
          >
            <div class="stats-badge secondary">
              <span class="badge-label">Waypoints</span>
              <span class="badge-value">{{ uploadedRoutePoints2.length }}</span>
            </div>
            <div class="stats-badge danger">
              <span class="badge-label">Total Distance</span>
              <span class="badge-value"
                >{{ getRouteDistance(uploadedRoutePoints2) }} NM</span
              >
            </div>
          </div>

          <div
            [id]="'route2-card-' + i"
            class="route-card route-2-card mb-3"
            [class.highlighted-card]="highlightedCardId === 'route2-card-' + i"
            [class.hovered-card]="hoveredCardId === 'route2-card-' + i"
            (mouseenter)="onCardMouseEnter(2, i)"
            (mouseleave)="onCardMouseLeave(2, i)"
            *ngFor="let point of uploadedRoutePoints2; let i = index"
          >
            <!-- Header -->
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h5 class="mb-0 font-semibold text-sm">
                Waypoint {{ point.WPT_No }}
              </h5>

              <div class="d-flex align-items-center">
                <mat-icon
                  matTooltip="Locate on Map"
                  class="text-primary cursor-pointer me-2"
                  style="font-size: 16px; width: 16px; height: 16px"
                  (click)="panToWaypointCard(point)"
                >
                  location_searching
                </mat-icon>

                <mat-icon
                  matTooltip="Add Waypoint"
                  class="text-success cursor-pointer me-2"
                  style="font-size: 16px; width: 16px; height: 16px"
                  (click)="addRow(i, uploadedRoutePoints2)"
                >
                  add_circle
                </mat-icon>

                <mat-icon
                  *ngIf="point.isAdded"
                  matTooltip="Remove Waypoint"
                  class="text-danger cursor-pointer"
                  style="font-size: 16px; width: 16px; height: 16px"
                  (click)="removeRow(i, uploadedRoutePoints2)"
                >
                  remove_circle
                </mat-icon>
              </div>
            </div>

            <!-- Compact Fields -->
            <div class="row g-2 align-items-end">
              <div class="col-4">
                <label class="compact-label">Latitude</label>
                <input
                  type="number"
                  class="form-control compact-input"
                  [(ngModel)]="point.LAT"
                  (change)="
                    recalculateWaypointDistances(uploadedRoutePoints2);
                    drawSecondUploadedRoute(uploadedRoutePoints2)
                  "
                />
              </div>

              <div class="col-4">
                <label class="compact-label">Longitude</label>
                <div class="input-group input-group-sm">
                  <input
                    type="number"
                    class="form-control compact-input"
                    style="
                      border-top-right-radius: 0;
                      border-bottom-right-radius: 0;
                    "
                    [(ngModel)]="point.LONG"
                    (change)="
                      recalculateWaypointDistances(uploadedRoutePoints2);
                      drawSecondUploadedRoute(uploadedRoutePoints2)
                    "
                  />
                  <span
                    *ngIf="point.isAdded"
                    class="input-group-text p-1 cursor-pointer bg-white"
                    style="
                      border-top-left-radius: 0;
                      border-bottom-left-radius: 0;
                    "
                    (click)="
                      enableWaypointLocationSelect(point, uploadedRoutePoints2)
                    "
                    matTooltip="Pick location from map"
                  >
                    <mat-icon style="font-size: 14px; width: 14px; height: 14px"
                      >my_location</mat-icon
                    >
                  </span>
                </div>
              </div>

              <div class="col-4">
                <label class="compact-label">Sail</label>
                <select
                  class="form-select form-control compact-input"
                  [(ngModel)]="point['Sail(RL/GC)']"
                  (change)="
                    recalculateWaypointDistances(uploadedRoutePoints2);
                    drawSecondUploadedRoute(uploadedRoutePoints2)
                  "
                >
                  <option value="RL">RL</option>
                  <option value="GC">GC</option>
                </select>
              </div>
            </div>

            <!-- Compact Stats Footer -->
            <div class="card-footer-stats">
              <div class="leg-info">
                Leg:
                <b>{{
                  (point["Sail(RL/GC)"] === "GC"
                    ? point.GC_Distance_NM
                    : point.RL_Distance_NM) || 0
                }}</b>
                NM
                <span class="text-slate-400 font-normal">
                  (GC: {{ point.GC_Distance_NM || 0 }} / RL:
                  {{ point.RL_Distance_NM || 0 }})</span
                >
              </div>
              <div class="total-info">
                Total: {{ point.Total_Distance_NM || 0 }} NM
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="route-card-container mt-3"
        *ngIf="uploadedRoutePoints.length > 0"
      >
        <div class="route-section-header">
          <h3 class="mb-0">Route Points</h3>

          <button
            type="button"
            class="route-expand-btn"
            (click)="toggleRoutePoints()"
            [matTooltip]="
              routePointsExpanded
                ? 'Collapse Route Points'
                : 'Expand Route Points'
            "
          >
            <mat-icon>
              {{ routePointsExpanded ? "expand_less" : "expand_more" }}
            </mat-icon>
          </button>
        </div>
        <div *ngIf="routePointsExpanded">
          <!-- Stats Banners -->
          <div
            class="route-header-summary d-flex gap-2 align-items-center mb-3 flex-wrap"
          >
            <div class="stats-badge secondary">
              <span class="badge-label">Waypoints</span>
              <span class="badge-value">{{ uploadedRoutePoints.length }}</span>
            </div>
            <div class="stats-badge success">
              <span class="badge-label">Total Distance</span>
              <span class="badge-value"
                >{{ getRouteDistance(uploadedRoutePoints) }} NM</span
              >
            </div>
          </div>

          <div
            [id]="'route-card-' + i"
            class="route-card single-route-card mb-3"
            [class.highlighted-card]="highlightedCardId === 'route-card-' + i"
            [class.hovered-card]="hoveredCardId === 'route-card-' + i"
            (mouseenter)="onCardMouseEnter(0, i)"
            (mouseleave)="onCardMouseLeave(0, i)"
            *ngFor="let point of uploadedRoutePoints; let i = index"
          >
            <!-- Header -->
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h5 class="mb-0 font-semibold text-sm">
                Waypoint {{ point.WPT_No }}
              </h5>

              <div class="d-flex align-items-center">
                <mat-icon
                  matTooltip="Locate on Map"
                  class="text-primary cursor-pointer me-2"
                  style="font-size: 16px; width: 16px; height: 16px"
                  (click)="panToWaypointCard(point)"
                >
                  location_searching
                </mat-icon>

                <mat-icon
                  matTooltip="Add Waypoint"
                  class="text-success cursor-pointer me-2"
                  style="font-size: 16px; width: 16px; height: 16px"
                  (click)="addRow(i, uploadedRoutePoints)"
                >
                  add_circle
                </mat-icon>

                <mat-icon
                  *ngIf="point.isAdded"
                  matTooltip="Remove Waypoint"
                  class="text-danger cursor-pointer"
                  style="font-size: 16px; width: 16px; height: 16px"
                  (click)="removeRow(i, uploadedRoutePoints)"
                >
                  remove_circle
                </mat-icon>
              </div>
            </div>

            <!-- Compact Fields -->
            <div class="row g-2 align-items-end">
              <div class="col-4">
                <label class="compact-label">Latitude</label>
                <input
                  type="number"
                  class="form-control compact-input"
                  [(ngModel)]="point.LAT"
                  (change)="
                    recalculateWaypointDistances(uploadedRoutePoints);
                    drawUploadedRoute(uploadedRoutePoints)
                  "
                />
              </div>

              <div class="col-4">
                <label class="compact-label">Longitude</label>
                <div class="input-group input-group-sm">
                  <input
                    type="number"
                    class="form-control compact-input"
                    style="
                      border-top-right-radius: 0;
                      border-bottom-right-radius: 0;
                    "
                    [(ngModel)]="point.LONG"
                    (change)="
                      recalculateWaypointDistances(uploadedRoutePoints);
                      drawUploadedRoute(uploadedRoutePoints)
                    "
                  />
                  <span
                    *ngIf="point.isAdded"
                    class="input-group-text p-1 cursor-pointer bg-white"
                    style="
                      border-top-left-radius: 0;
                      border-bottom-left-radius: 0;
                    "
                    (click)="
                      enableWaypointLocationSelect(point, uploadedRoutePoints)
                    "
                    matTooltip="Pick location from map"
                  >
                    <mat-icon style="font-size: 14px; width: 14px; height: 14px"
                      >my_location</mat-icon
                    >
                  </span>
                </div>
              </div>

              <div class="col-4">
                <label class="compact-label">Sail</label>
                <select
                  class="form-select form-control compact-input"
                  [(ngModel)]="point['Sail(RL/GC)']"
                  (change)="
                    recalculateWaypointDistances(uploadedRoutePoints);
                    drawUploadedRoute(uploadedRoutePoints)
                  "
                >
                  <option value="RL">RL</option>
                  <option value="GC">GC</option>
                </select>
              </div>
            </div>

            <!-- Compact Stats Footer -->
            <div class="card-footer-stats">
              <div class="leg-info">
                Leg:
                <b>{{
                  (point["Sail(RL/GC)"] === "GC"
                    ? point.GC_Distance_NM
                    : point.RL_Distance_NM) || 0
                }}</b>
                NM
                <span class="text-slate-400 font-normal">
                  (GC: {{ point.GC_Distance_NM || 0 }} / RL:
                  {{ point.RL_Distance_NM || 0 }})</span
                >
              </div>
              <div class="total-info">
                Total: {{ point.Total_Distance_NM || 0 }} NM
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="simulation-error-banner-bottom"
        class="alert alert-danger mx-3 mt-3 mb-2 d-flex align-items-start"
        *ngIf="simulationError"
        style="border-radius: 8px; border-left: 5px solid #dc3545; background-color: #fff5f5; color: #721c24; box-shadow: 0 2px 8px rgba(220,53,69,0.15); padding: 14px 16px;"
      >
        <i class="fa-solid fa-triangle-exclamation me-3 mt-1" style="font-size: 20px; color: #dc3545;"></i>
        <div style="flex: 1;">
          <h5 style="margin: 0 0 4px 0; font-weight: 700; color: #dc3545; font-size: 14px;">Route Simulation Notice / Error</h5>
          <p style="margin: 0; font-size: 13px; line-height: 1.5; white-space: pre-wrap;">{{ simulationError }}</p>
        </div>
        <button type="button" class="btn-close ms-2" (click)="simulationError = null" aria-label="Close" style="background-size: 10px;"></button>
      </div>
      <div class="sidebar-action-bar">
        <div
          class="text-right"
          *ngIf="
            selectedType !== 'jupiter Route' && selectedType !== 'Upload Route'
          "
        >
          <!-- <button
            class="btn btn-light hover-button mail"
            (click)="fetchClick()"
          >
            <mat-icon>done</mat-icon> Fetch Route
          </button> -->
          <button
            *ngIf="selectedTab === false"
            class="btn btn-light hover-button mail"
            [disabled]="isSubmitting"
            (click)="submitClick()"
          >
            <mat-icon *ngIf="!isSubmitting">done</mat-icon>
            <mat-spinner *ngIf="isSubmitting" diameter="18" style="display:inline-block; margin-right:6px;"></mat-spinner>
            Submit
          </button>
          <button
            *ngIf="selectedTab === true"
            class="btn btn-light hover-button mail"
            [disabled]="isSubmitting"
            [matTooltip]="!isRouteCsvUploaded() ? 'Please upload a CSV/Excel route file first' : ''"
            (click)="jupiterSubmitClick()"
          >
            <mat-icon *ngIf="!isSubmitting">done</mat-icon>
            <mat-spinner *ngIf="isSubmitting" diameter="18" style="display:inline-block; margin-right:6px;"></mat-spinner>
            Submit
          </button>
        </div>
        <div class="button-container" *ngIf="selectedType === 'jupiter Route'">
          <button
            class="btn btn-light hover-button mail route-comp"
            (click)="multipleRouteAndSpeedCompClick()"
          >
            <mat-icon>{{
              isMultiRouteComp ? "toggle_on" : "compare_arrows"
            }}</mat-icon>
            Multiple route with multiple speed
          </button>

          <button
            class="btn btn-light hover-button mail route-comp"
            (click)="routeCompClick()"
          >
            <mat-icon>
              {{ isRouteComp ? "toggle_on" : "compare_arrows" }}
            </mat-icon>
            Same speed with multiple route
          </button>

          <button
            class="btn btn-light hover-button mail route-comp"
            [disabled]="isSubmitting"
            [matTooltip]="!isRouteCsvUploaded() ? 'Please upload a CSV/Excel route file first' : ''"
            (click)="jupiterSubmitClick()"
          >
            <mat-icon *ngIf="!isSubmitting">done</mat-icon>
            <mat-spinner *ngIf="isSubmitting" diameter="18" style="display:inline-block; margin-right:6px;"></mat-spinner>
            Submit
          </button>
        </div>

        <div class="text-right" *ngIf="selectedType === 'Upload Route'">
          <button
            class="btn btn-light hover-button mail"
            [disabled]="isSubmitting"
            [matTooltip]="!isRouteCsvUploaded() ? 'Please upload a CSV/Excel route file first' : ''"
            (click)="submitUploadRouteClick()"
          >
            <mat-icon>done</mat-icon> Submit
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="map-container">
    <div
      class="bg-gradient-to-r-custom border-b border-slate-600 mapContainer d-flex justify-content-between align-items-center flex-wrap gap-2 pr-3"
    >
      <div>
        <h1 class="text-xl font-semibold text-white flex items-center gap-2">
          Route Visualization
        </h1>
        <p class="text-slate-300 text-sm mt-1">Awaiting route generation</p>
      </div>
      <!-- Flat Interaction Guide -->
      <div class="map-guide-legend d-flex align-items-center gap-3">
        <div class="guide-item d-flex align-items-center gap-1 text-slate-300">
          <span class="guide-key">Drag</span>
          <span>waypoints to move</span>
        </div>
        <div class="guide-item d-flex align-items-center gap-1 text-slate-300">
          <span class="guide-key right-click">Right-Click</span>
          <span>waypoint to delete</span>
        </div>
      </div>
    </div>
    <div class="map-frame">
      <!-- Premium Maritime Routing Sidebar -->
      <div class="maritime-sidebar" [class.collapsed]="isSidebarCollapsed">
        <div class="sidebar-header">
          <div class="header-content" *ngIf="!isSidebarCollapsed">
            <mat-icon class="header-icon">anchor</mat-icon>
            <span class="header-title">Maritime Routing</span>
          </div>
          <button
            class="collapse-btn"
            (click)="isSidebarCollapsed = !isSidebarCollapsed"
            [matTooltip]="
              isSidebarCollapsed
                ? 'Expand Maritime Overlays'
                : 'Collapse Maritime Overlays'
            "
          >
            <mat-icon>{{
              isSidebarCollapsed ? "chevron_right" : "chevron_left"
            }}</mat-icon>
          </button>
        </div>

        <div class="sidebar-body" *ngIf="!isSidebarCollapsed">
          <!-- Layer Toggles -->
          <div class="sidebar-section">
            <h3 class="section-title">Overlay Zones</h3>
            <div class="layer-grid">
              <div
                class="layer-item"
                [class.active]="layerState.eca"
                (click)="
                  layerState.eca = !layerState.eca; toggleRoutingLayer('eca')
                "
              >
                <mat-icon [style.color]="'#10b981'">verified_user</mat-icon>
                <span>ECA</span>
              </div>
              <div
                class="layer-item"
                [class.active]="layerState.hra"
                (click)="
                  layerState.hra = !layerState.hra; toggleRoutingLayer('hra')
                "
              >
                <mat-icon [style.color]="'#ef4444'">gpp_maybe</mat-icon>
                <span>HRA</span>
              </div>
              <div
                class="layer-item"
                [class.active]="layerState.marpol"
                (click)="
                  layerState.marpol = !layerState.marpol;
                  toggleRoutingLayer('marpol')
                "
              >
                <mat-icon [style.color]="'#0d9488'">waves</mat-icon>
                <span>MARPOL</span>
              </div>
              <div
                class="layer-item"
                [class.active]="layerState.tss"
                (click)="
                  layerState.tss = !layerState.tss; toggleRoutingLayer('tss')
                "
              >
                <mat-icon [style.color]="'#8b5cf6'">lan</mat-icon>
                <span>TSS</span>
              </div>
              <div
                class="layer-item"
                [class.active]="layerState.piracy"
                (click)="
                  layerState.piracy = !layerState.piracy;
                  toggleRoutingLayer('piracy')
                "
              >
                <mat-icon [style.color]="'#f97316'">warning</mat-icon>
                <span>Piracy</span>
              </div>
              <div
                class="layer-item"
                [class.active]="layerState.inl"
                (click)="
                  layerState.inl = !layerState.inl; toggleRoutingLayer('inl')
                "
              >
                <mat-icon [style.color]="'#22d3ee'">Ac_unit</mat-icon>
                <span>INL</span>
              </div>
            </div>
          </div>

          <!-- Points of Interest -->
          <div class="sidebar-section">
            <h3 class="section-title">Points of Interest</h3>
            <div class="toggle-list">
              <div
                class="toggle-row"
                [class.active]="layerState.ports"
                (click)="
                  layerState.ports = !layerState.ports;
                  toggleRoutingPorts('major')
                "
              >
                <div class="toggle-info">
                  <mat-icon>location_city</mat-icon>
                  <span>Ports</span>
                </div>
                <mat-slide-toggle
                  [checked]="layerState.ports"
                  color="primary"
                ></mat-slide-toggle>
              </div>
              <div
                class="toggle-row"
                [class.active]="layerState.gates"
                (click)="
                  layerState.gates = !layerState.gates; toggleRoutingGates()
                "
              >
                <div class="toggle-info">
                  <mat-icon>{{
                    layerState.gates ? "lock_open" : "lock"
                  }}</mat-icon>
                  <span>Routing Gates</span>
                </div>
                <mat-slide-toggle
                  [checked]="layerState.gates"
                  color="primary"
                ></mat-slide-toggle>
              </div>
            </div>
          </div>

          <!-- Routing Logic -->
        </div>
      </div>
      <div
        class="globe-toggle-btn"
        (click)="toggleMapMode()"
        [matTooltip]="isGlobeMode ? 'Switch to 2D Map' : 'Switch to 3D Globe'"
      >
        <mat-icon>{{ isGlobeMode ? "map" : "public" }}</mat-icon>
        <span>{{ isGlobeMode ? "2D" : "3D" }}</span>
      </div>

      <!-- Globe-only controls -->
      <div class="globe-overlay-controls" *ngIf="isGlobeMode">
        <div
          class="globe-ctrl-btn"
          (click)="toggleGlobeWeather()"
          [matTooltip]="
            globeWeatherVisible ? 'Hide Wind Speed' : 'Show Wind Speed'
          "
        >
          <mat-icon>{{ globeWeatherVisible ? "cloud_off" : "cloud" }}</mat-icon>
          <span>Wind</span>
        </div>
        <div class="globe-zoom-group">
          <div
            class="globe-ctrl-btn"
            (click)="globeZoomIn()"
            matTooltip="Zoom In"
          >
            <mat-icon>add</mat-icon>
          </div>
          <div
            class="globe-ctrl-btn"
            (click)="globeZoomOut()"
            matTooltip="Zoom Out"
          >
            <mat-icon>remove</mat-icon>
          </div>
        </div>
      </div>

      <div
        id="map"
        class="map"
        [style.display]="isGlobeMode ? 'none' : 'block'"
      ></div>
      <div
        id="globe"
        class="globe"
        [style.display]="isGlobeMode ? 'block' : 'none'"
      ></div>
    </div>
  </div>

  <!-- Speed & Consumption Floating Menu -->
  <div
    class="tcp-floating-menu"
    [class.open]="isTcpMenuOpen"
    *ngIf="vesselTcpSpeedConsumption && vesselTcpSpeedConsumption.length > 0"
  >
    <div
      class="menu-toggle-tab"
      (click)="isTcpMenuOpen = !isTcpMenuOpen"
      [matTooltip]="
        isTcpMenuOpen ? 'Hide Speed & Consumption' : 'Show Speed & Consumption'
      "
    >
      <mat-icon>{{ isTcpMenuOpen ? "chevron_right" : "speed" }}</mat-icon>
      <span class="tab-text" *ngIf="!isTcpMenuOpen">Speed & Cons</span>
    </div>

    <div class="menu-content">
      <div class="menu-header">
        <h4>Performance Data</h4>
        <button class="close-btn" (click)="isTcpMenuOpen = false">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="menu-body scroll-bar">
        <div
          class="tcp-vessel-card"
          *ngFor="let item of getFilteredTcpSpeedConsumption()"
        >
          <div class="card-header">
            <span class="cond-badge" [ngClass]="item.condition.toLowerCase()">{{
              item.condition
            }}</span>
            <span class="client-info">{{ item.client }}</span>
          </div>

          <table class="tcp-mini-table">
            <thead>
              <tr>
                <th>Speed</th>
                <th style="text-align: right">Consumption</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let speed of getObjectKeys(item.speed_consumption)">
                <td>{{ speed }} kts</td>
                <td style="text-align: right; font-weight: 600; color: #3b82f6">
                  {{ item.speed_consumption[speed] }} MT
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          *ngIf="getFilteredTcpSpeedConsumption().length === 0"
          style="
            padding: 20px;
            text-align: center;
            color: #94a3b8;
            font-size: 13px;
          "
        >
          No speed consumption data found for the selected condition.
        </div>
      </div>
    </div>
  </div>
</div>
